import * as $ from 'jquery';
import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from './../node_modules/photoswipe/dist/photoswipe-ui-default';

$(document).ready(function() {
    var items = [];
    var itemsData = [];

    $.each($('.photoswipe'), function(i, element) {
        items.push($(element));
        itemsData.push($(element).data());
    });

    $.each($('.photoswipe'), function(i, element) {
        let item = $(element);
        item.click(function() {           
            var pswpElement = document.querySelectorAll('.pswp')[0] as HTMLElement;;
            var options = {
                index: i,
                counterEl: false,
                showHideOpacity: true,
                getThumbBoundsFn: function(j) {
                    return {x:items[j].offset().left, y:items[j].offset().top, w:items[j].width(), h:1000};
                }
            };

            var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, itemsData, options);
            gallery.init();
        });
    });
    
    var hash = window.location.hash.split('&');
    var hashQuery: any = {};
     $.each(hash, function(i, ah) {
         var ha = ah.split("=");
         hashQuery[ha[0]] = ha[1];
    })

     if (hashQuery.gid && hashQuery.pid) {
         items[hashQuery.pid].click();
     }
});